import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
export function AppRouter() {
  return <BrowserRouter data-id="element-14">
      <Routes data-id="element-15">
        <Route path="/" element={<App data-id="element-17" />} data-id="element-16" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-19" />} data-id="element-18" />
        <Route path="/terms" element={<TermsOfService data-id="element-21" />} data-id="element-20" />
      </Routes>
    </BrowserRouter>;
}